const ignore = ['favorite', 'memoid'];
export const clearLocalStorageOnLogout = () => {
  Object.keys(localStorage).forEach((key) =>
    !ignore.includes(key) ? localStorage.removeItem(key) : ""
  );
};
